import { LoggingBase, LoggingTypes, ConsoleAdapter } from "@hibas123/logging";

const loggingInstances = new Map<string, LoggingBase>();
const enabled = new Set<string>();

(localStorage.getItem("LOGGING_ENABLED") || "")
   .split(";")
   .forEach(e => enabled.add(e));

export function getLogging(id: string) {
   let logging = loggingInstances.get(id);
   if (!logging) {
      logging = new LoggingBase({
         name: id,
         console: false
      });

      console.log(logging);

      logging.addAdapter(new ConsoleAdapter());

      loggingInstances.set(id, logging);
      logging.logLevel = enabled.has(id)
         ? LoggingTypes.Debug
         : LoggingTypes.Error;
   }

   return logging;
}

export function enableLogging(logging: LoggingBase) {
   if (!loggingInstances.has(logging.name)) {
      loggingInstances.set(logging.name, logging);
      logging.addAdapter(new ConsoleAdapter());
      logging.logLevel = enabled.has(logging.name)
         ? LoggingTypes.Debug
         : LoggingTypes.Error;
   }
}

export function toggleLogging(id: string) {
   let newstate;
   if (enabled.has(id)) {
      enabled.delete(id);
      let ins = loggingInstances.get(id);
      if (ins) ins.logLevel = LoggingTypes.Error;
      newstate = false;
   } else {
      enabled.add(id);
      let ins = loggingInstances.get(id);
      if (ins) ins.logLevel = LoggingTypes.Debug;
      newstate = true;
   }

   localStorage.setItem(
      "LOGGING_ENABLED",
      Array.from(enabled.values()).join(";")
   );

   return newstate;
}

(window as any).toggleLogging = (id: string) => toggleLogging(id);
(window as any).showLogging = () => {
   return loggingInstances;
};
